import { ApplicationState } from '@/store';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IUniId } from 'types';

export const useUniStaffUniversities = () => {
  const { role } = useSelector(({ auth }: ApplicationState) => ({
    role: auth.role,
  }));

  const configUniIds: IUniId[] = useSelector(({ config }: ApplicationState) => config.universityIds || []);
  const configUniCode: IUniId = useSelector(({ config }: ApplicationState) => ({
    value: config.university_code,
    label: config.university_name,
    fullName: config.university_name,
  }));
  const applyAccess = useSelector(({ config }: ApplicationState) => config.applyEnabled || []);

  // Only process agent-specific universities if the user is an agent
  // Only add configUniCode if it doesn't already exist in configUniIds to prevent duplicates
  const universities = useMemo(() => {
    const validUniIds = configUniIds.filter(ind => Boolean(ind) && Object.keys(ind).every(key => Boolean(ind[key])));

    // Only add configUniCode if it's valid and not already in the list
    if (configUniCode?.value && !validUniIds.some(uni => uni.value === configUniCode.value)) {
      return [...validUniIds, configUniCode];
    }

    return validUniIds;
  }, [role, configUniIds, configUniCode]);

  return {
    universities,
    hasAccessToApply: applyAccess ?? false,
    isLoading: !(configUniIds?.length > 0),
  };
};
